import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IConfirmOrEditMarkerLocationOnMapMetadata } from '@repo/ui';
import {
  GetAllInternshipLocationsUseCaseInterface,
  GetInternshipLocationByIdUseCaseInterface,
} from 'domain/usecases';

interface IInternshipLocationsState {
  internshipLocationsListData: GetAllInternshipLocationsUseCaseInterface.Result;
  selectedInternshipLocationData: GetInternshipLocationByIdUseCaseInterface.Result;
  confirmOrEditMarkerLocationOnMapMetadata: IConfirmOrEditMarkerLocationOnMapMetadata;
}

interface IPayloadInternshipLocationsListData
  extends PayloadAction<GetAllInternshipLocationsUseCaseInterface.Result> {}

interface IPayloadSelectedInternshipLocationData
  extends PayloadAction<GetInternshipLocationByIdUseCaseInterface.Result> {}

interface IPayloadConfirmMarkerLocationOnMap
  extends PayloadAction<IConfirmOrEditMarkerLocationOnMapMetadata> {}

const initialState: IInternshipLocationsState = {
  internshipLocationsListData: null,
  selectedInternshipLocationData: null,
  confirmOrEditMarkerLocationOnMapMetadata: null,
};

export const InternshipLocationsSlice = createSlice({
  name: 'internship-locations-slice',
  initialState,
  reducers: {
    loadInternshipLocationsListData: (
      state,
      action: IPayloadInternshipLocationsListData,
    ) => {
      state.internshipLocationsListData = action.payload;
    },
    clearInternshipLocationsListData: (state) => {
      state.internshipLocationsListData = null;
    },
    loadSelectedInternshipLocationData: (
      state,
      action: IPayloadSelectedInternshipLocationData,
    ) => {
      state.selectedInternshipLocationData = action.payload;
    },
    clearSelectedInternshipLocationData: (state) => {
      state.selectedInternshipLocationData = null;
    },
    loadConfirmOrEditMarkerLocationOnMapMetadata: (
      state,
      action: IPayloadConfirmMarkerLocationOnMap,
    ) => {
      state.confirmOrEditMarkerLocationOnMapMetadata = action.payload;
    },
    clearConfirmOrEditMarkerLocationOnMapMetadata: (state) => {
      state.confirmOrEditMarkerLocationOnMapMetadata = null;
    },
  },
});

export const {
  loadInternshipLocationsListData,
  clearInternshipLocationsListData,
  loadSelectedInternshipLocationData,
  clearSelectedInternshipLocationData,
  loadConfirmOrEditMarkerLocationOnMapMetadata,
  clearConfirmOrEditMarkerLocationOnMapMetadata,
} = InternshipLocationsSlice.actions;

export default InternshipLocationsSlice.reducer;
